import * as React from 'react'
import { useActions } from './useActions'
import { LeadListViewProps } from './typings'
import { BulkAddLeadActivities, WWMXGrid } from '@user/components/xGrid'
import { GridState, GridDensity } from '@mui/x-data-grid-pro'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

import {
  lockedLeadColumns,
  defaultLeadColVis,
  defaultLeadColumns,
} from './leadListColumns'
import {
  BulkReopenLeads,
  BulkReassignLeads,
  BulkUpdateLeadStatus,
  LeadBulkActions,
} from './LeadBulkActions'

import {
  userGeneralPreferencesList,
  IUserPreferenceGeneralListItemType,
  saveGeneralPreferences,
} from '@user/store/userPreferences/userPreferencesGeneral'

export function LeadListView(props: LeadListViewProps) {
  const {
    loading,
    page,
    perPage,
    count,
    columns,
    rows,
    columnVisibility,
    exportClickCallback,
  } = props

  const dispatch = useAppDispatch()

  const userGeneralPreferences = useSelector(userGeneralPreferencesList)

  const {
    handlePaginationModelChange,
    sortModel,
    onSortModelChange,
    onSaveColumnState,
    selectionChangeCallback,
    onColumnWidthChange,
  } = useActions(props)

  const createActivityBulkAction = BulkAddLeadActivities

  const densityModeUserGeneralPreference = userGeneralPreferences?.find(
    (row) => row?.type == IUserPreferenceGeneralListItemType.LeadDensityMode,
  )

  const stringValue = densityModeUserGeneralPreference?.value ?? 'standard'
  const densityMode = stringValue as GridDensity

  const onStateChange = (state: GridState) => {
    if (state.density) {
      onDensityChange(state.density.value)
    }
  }

  const onDensityChange = (density: string) => {
    if (densityMode != density) {
      dispatch(
        saveGeneralPreferences({
          type: IUserPreferenceGeneralListItemType.LeadDensityMode,
          value: density,
        }),
      )
    }
  }

  return (
    <WWMXGrid
      loading={loading}
      // columns
      columnVisibilityModel={columnVisibility}
      columns={columns}
      onColumnWidthChange={(e) =>
        onColumnWidthChange(e?.colDef, columns, columnVisibility)
      }
      columnsSelectorProps={{
        saveCallback: (e) => onSaveColumnState(e, columns),
        lockedColumns: lockedLeadColumns,
        defaultColumns: defaultLeadColumns,
        defaultVisibility: defaultLeadColVis,
      }}
      BulkActions={LeadBulkActions}
      bulkActionSidebars={{
        updateSalesFunnel: BulkUpdateLeadStatus,
        reopen: BulkReopenLeads,
        reassign: BulkReassignLeads,
        createActivity: createActivityBulkAction,
      }}
      //state
      isDensityEnable
      isExportEnable
      density={densityMode}
      onStateChange={onStateChange}
      //export
      exportClickCallback={exportClickCallback}
      // rows
      rows={rows}
      rowCount={count}
      // pagination
      paginationModel={{ page: page - 1, pageSize: perPage }}
      onPaginationModelChange={handlePaginationModelChange}
      // sorting
      sortModel={sortModel}
      onSortModelChange={onSortModelChange}
      selectionChangeCallback={selectionChangeCallback}
      width="100%"
    />
  )
}
LeadListView.displayName = 'LeadListView'
